import { BrowserRouter, Route, Routes } from 'react-router-dom';
import GuestTemplate from './pages/GuestTemplate';
import Home from './pages/guest/Home';
import About from './pages/guest/About';
import Login from './pages/Login'
import Bendahara from './auth/Bendahara';
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import { useState } from 'react';
import Verifikator from './auth/Verifikator';
import Admin from './auth/Admin';

function App() {
    const [mode, setMode] = useState("light");

    const theme = createTheme({
        palette: {
            mode: mode,
            ...(mode === 'dark' ? {
                // breadcrumbsBg: "#1d1d1d",
                breadcrumbsBg: "linear-gradient(45deg, rgb(68, 50, 84), rgb(57, 102, 117))",
                breadcrumbsColor: "rgb(245, 5, 85)"
            } : {
                breadcrumbsBg: "linear-gradient(45deg, rgb(92, 37, 141), rgb(67, 137, 162))",
                breadcrumbsColor: "rgb(255, 64, 129)"
            })
        },
        typography: {
            fontFamily: [
                "muli-regular",
                '-apple-system',
                'BlinkMacSystemFont',
                '"poppins"',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                '"Noto Sans"',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
                "Noto Color Emoji",
            ].join(','),
        },
    });

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <BrowserRouter>
                <Routes>
                    <Route exact path='/' element={<Home />} />

                    {/* <Route path='/bnd/*' element={<Bendahara component={<BendaharaTemplate setMode={setMode} mode={mode} />} />} /> */}
                    <Route path='/bnd/*' element={<Bendahara setMode={setMode} mode={mode} />} />

                    <Route path='/verif/*' element={<Verifikator setMode={setMode} mode={mode} />} />

                    <Route path='/admin/*' element={<Admin setMode={setMode} mode={mode} />} />

                    <Route exact path='/login' element={<Login />} />
                    <Route exact path='*' element={<Home />} />

                </Routes>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
